var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage"},[_c('div',{staticClass:"header"}),_c('div',{staticClass:"body"},[_c('a-result',{attrs:{"status":"500","title":"主页内容设计中..."}})],1),_c('div',{staticClass:"footer"})])}
var staticRenderFns = []

export { render, staticRenderFns }